import React, { useState } from 'react'
import styles from './styles.module.scss'
import warningSVG from '../../assets/icons/circle-warning.svg'
import successSVG from '../../assets/icons/circle-check.svg'
import Button from '../../UI/Button/Button'
import InfoModal from '../InfoModal/InfoModal'

export default function ModerationStatus({ data }) {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)

  const getCurrentMessage = () => {
    let alert
    if (data.allow_moderation && !data.on_moderation) {
      alert = 'Check information and submit for moderation'
    } else if (!data.allow_moderation && !data.on_moderation && !data.is_active) {
      alert = 'You must fill out the information and go through the moderation process'
    } else if (data.on_moderation && !data.is_active) {
      alert = 'Your information is under moderation. You can update your details while it’s being reviewed.'
    } else if (data.on_moderation && data.is_active) {
      alert =
        `If you need to update your basic information, you can do so on your own. You also have the option to add additional information about your company. Your company can now go through re-moderation by changing any of the required fields, including the logo.`
    } else {
      alert = null
    }
    return alert
  }

  return (
    <>
      <div className={styles.block}>
        <div className={styles.content}>
          <img className={styles.icon_status} src={data.is_active ? successSVG : warningSVG} alt="to your information" />
          <div className={styles.message}>
            <div className={styles.title}>
              {data.is_active ? (
                <p>
                  Your account status is{' '}
                  <span className={styles.accent} style={{ color: '#1CCF9E' }}>
                    ENABLED
                  </span>
                </p>
              ) : (
                <p>
                  Your account status is{' '}
                  <span className={styles.accent} style={{ color: '#c20000' }}>
                    {' '}
                    not active yet{' '}
                  </span>{' '}
                </p>
              )}
            </div>
            <div className={styles.description}>{getCurrentMessage()}</div>
          </div>
        </div>

        {!data.is_active && (
          <Button type="button" size="middle" className={styles.actionButton} onClick={() => setIsInfoModalOpen(true)}>
            Moderation
          </Button>
        )}
      </div>
      {isInfoModalOpen && <InfoModal onClose={() => setIsInfoModalOpen(false)} />}
    </>
  )
}
